export default __webpack_public_path__ + "static/Museo-Sans-300-9ad7433bf7845384dc83bb1e1dc0f4c0.woff";